export default "__VITE_ASSET__DAoiRlVl__"